<template>
  <div class="event-calendar">
    <b-container fluid>
      <b-row align-v="center">
        <b-col style="font-size: 1.5rem;">
          <b-button @click="changeMonth('prev')" size="sm" variant="primary" :disabled="this.isLoading"><b-icon icon="arrow-left"></b-icon></b-button>
          <label class="mx-2">{{year}} / {{monthNames[month]}}</label>
          <b-button @click="changeMonth('next')" size="sm" variant="primary" :disabled="this.isLoading"><b-icon icon="arrow-right"></b-icon></b-button>
        </b-col>
      </b-row>
      <p v-if="!this.isLoading && this.quotes.length == 0 && this.style != 'monthly'">No records.</p>
      <b-spinner v-if="this.isLoading" variant="primary" label="Spinning"></b-spinner>
      <b-row v-if="this.style == 'monthly' && !this.isLoading" class="monthly">
        <b-col cols="4" lg="2" v-for="(day, index) in this.months[month]" :key="'day' + index" class="day-grid">
          <p>{{day.day}}</p>
          <div v-for="(quote, i) in day.quotes" :key="'quotes' + i">
            <p class="event-name" @click="showDetails(quote)">{{quote.created_by_name}} - {{quote.customer_name}}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'QuoteCalendar',
  props: {
    user: Object
  },
  data() {
    return {
      maleMonth: [4, 6, 9, 11],
      isLoading: false,
      date: "",
      monthNames: ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      year: 0,
      month: 0,
      yearMonth: "",
      quotes: [],
      style: "monthly",
      months: [],
    }
  },
  mounted() {
    this.yearMonth = this.year + '-' + String(this.month + 1).padStart(2, '0');
  },
  watch: {
    yearMonth(newYearMonth) {
      this.filterByYearMonth(newYearMonth);
    },
  },
  created() {
    this.initiateMonths();
    var today = new Date();
    this.month = today.getMonth();
    this.year = today.getFullYear();
  },
  methods: {
    changeMonth(mode) {
      //console.log(this.months);
      if (mode == "next") {
        if (this.month + 1 > 11) {
          this.month = (this.month + 1) % 12;
          this.year += 1;
        } else {
          this.month += 1;
        }
      } else if (mode == "prev") {
        if (this.month - 1 < 0) {
          this.month = 11;
          this.year -= 1;
        } else {
          this.month -= 1;
        }
      }

      this.yearMonth = this.year + '-' + String(this.month + 1).padStart(2, '0');
    },
    filterByYearMonth(yearMonth) {
      const self = this;
      if(this.user.role == 'sales') {
        firebase.firestore().collection('quotes')
        .where("created_by.id","==",this.user.id)
        .where("create_year_month", "==", yearMonth)
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            this.initiateMonths();
            collection.docs.forEach(doc => {
              const index = doc.data().create_day - 1;
              const quote = doc.data();

              this.quotes.push(quote);
              self.months[self.month][index].quotes.push(quote)
            })
          }
        });
      } else {
        firebase.firestore().collection('quotes')
        .where("create_year_month", "==", yearMonth)
        .onSnapshot((collection) => {
          if (collection.docs.length > 0) {
            this.initiateMonths();
            collection.docs.forEach(doc => {
              const index = doc.data().create_day - 1;
              const quote = doc.data();

              this.quotes.push(quote);
              self.months[self.month][index].quotes.push(quote);
            })
          }
        });
      }
    },
    showDetails(quote) {
      this.$emit('viewQuote', {quote: quote, from: 'QuoteCalendar'});
    },
    changeStyle(style) {
      this.style = style;
    },
    initiateMonths() {
      this.months = [];
      for (var i = 0; i < 12; i++) {
        var numberOfDays = 31;
        if (this.maleMonth.includes(i + 1)) {
          numberOfDays = 30;
        } else if (i + 1 == 2) {
          numberOfDays = 29;
        }
        var month = [];
        for (var c = 0; c < numberOfDays; c++) {
          month.push({day: c+1, 
            quotes: []});
        }
        this.months.push(month);
      }
    },
  },
}
</script>

<style>
.event-calendar {
  margin: 0;
}

.event-calendar .worker-name {
  margin: 0;
}

.event-calendar .day-grid {
  border: 1px solid #000;
  min-height: 100px;
}

.event-calendar .day-grid p{
  margin: 0;
}

.event-calendar .day-grid .event-name {
  color: blue;
  display: inline;
  text-decoration: underline;
  cursor: pointer;
}

.event-calendar .day-grid .event-badge {
  margin: 0;
  display: inline;
}

.event-calendar .event-name {
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 400px;
}

.event-calendar .active {
  color: green;
}

.event-calendar .completed {
  color: gray;
}

.event-calendar .namebadege {
  margin: 0;
}
</style>